/* GENERATED FILE */
import type { ReactElement } from "react";
import { Fragment } from "react";
import type { IconVariant } from "../lib";

export default new Map<IconVariant, ReactElement>([
	[
		"duocolor",
		<Fragment key={"duocolor"}>
			<path
				opacity="0.4"
				d="M8.99998 18.0002H15M6 14.0002H18"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M8 10H16M6 6H18M10 22H14C16.8003 22 18.2004 22 19.27 21.455C20.2108 20.9757 20.9757 20.2108 21.455 19.27C22 18.2004 22 16.8003 22 14V10C22 7.19974 22 5.79961 21.455 4.73005C20.9757 3.78924 20.2108 3.02433 19.27 2.54497C18.2004 2 16.8003 2 14 2H10C7.19974 2 5.79961 2 4.73005 2.54497C3.78924 3.02433 3.02433 3.78924 2.54497 4.73005C2 5.79961 2 7.19974 2 10V14C2 16.8003 2 18.2004 2.54497 19.27C3.02433 20.2108 3.78924 20.9757 4.73005 21.455C5.79961 22 7.19974 22 10 22Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"duotone",
		<Fragment key={"duotone"}>
			<rect
				opacity="0.12"
				x="2"
				y="2"
				width="20"
				height="20"
				rx="5"
				fill="currentColor"
			/>
			<path
				d="M9 18H15M6 14H18M8 10H16M6 6H18M10 22H14C16.8003 22 18.2004 22 19.27 21.455C20.2108 20.9757 20.9757 20.2108 21.455 19.27C22 18.2004 22 16.8003 22 14V10C22 7.19974 22 5.79961 21.455 4.73005C20.9757 3.78924 20.2108 3.02433 19.27 2.54497C18.2004 2 16.8003 2 14 2H10C7.19974 2 5.79961 2 4.73005 2.54497C3.78924 3.02433 3.02433 3.78924 2.54497 4.73005C2 5.79961 2 7.19974 2 10V14C2 16.8003 2 18.2004 2.54497 19.27C3.02433 20.2108 3.78924 20.9757 4.73005 21.455C5.79961 22 7.19974 22 10 22Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"filled",
		<Fragment key={"filled"}>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M3.98005 1.79497C5.04961 1.25 6.44974 1.25 9.25 1.25L14.75 1.25C17.5503 1.25 18.9504 1.25 20.02 1.79497C20.9608 2.27434 21.7257 3.03924 22.205 3.98005C22.75 5.04961 22.75 6.44974 22.75 9.25L22.75 14.75L22.75 14.75C22.75 17.5503 22.75 18.9504 22.205 20.02C21.7257 20.9608 20.9608 21.7257 20.02 22.205C18.9504 22.75 17.5503 22.75 14.75 22.75L9.25 22.75C6.44974 22.75 5.04961 22.75 3.98005 22.205C3.03924 21.7257 2.27433 20.9608 1.79497 20.02C1.25 18.9504 1.25 17.5503 1.25 14.75L1.25 9.25C1.25 6.44974 1.25 5.04961 1.79497 3.98005C2.27433 3.03924 3.03924 2.27434 3.98005 1.79497ZM6.00005 5.25016C5.58583 5.25016 5.25005 5.58594 5.25005 6.00016C5.25005 6.41437 5.58583 6.75016 6.00005 6.75016L18 6.75016C18.4142 6.75016 18.75 6.41437 18.75 6.00016C18.75 5.58594 18.4142 5.25016 18 5.25016L6.00005 5.25016ZM8.00004 9.25015C7.58583 9.25015 7.25004 9.58594 7.25004 10.0002C7.25004 10.4144 7.58583 10.7502 8.00004 10.7502L16 10.7502C16.4142 10.7502 16.75 10.4144 16.75 10.0002C16.75 9.58594 16.4142 9.25015 16 9.25015L8.00004 9.25015ZM6.00005 13.2501C5.58583 13.2501 5.25005 13.5859 5.25005 14.0001C5.25005 14.4144 5.58583 14.7501 6.00005 14.7501L18 14.7501C18.4142 14.7501 18.75 14.4144 18.75 14.0001C18.75 13.5859 18.4142 13.2501 18 13.2501L6.00005 13.2501ZM9.00003 17.2501C8.58582 17.2502 8.25003 17.5859 8.25003 18.0001C8.25003 18.4144 8.58582 18.7502 9.00003 18.7501L15 18.7501C15.4142 18.7501 15.75 18.4144 15.75 18.0001C15.75 17.5859 15.4142 17.2501 15 17.2501L9.00003 17.2501Z"
				fill="currentColor"
			/>
		</Fragment>,
	],
	[
		"gestalt",
		<Fragment key={"gestalt"}>
			<path
				d="M9.5 2L9 2V2C7.13872 2 6.20808 2 5.45492 2.24472C3.93273 2.73931 2.73931 3.93273 2.24472 5.45492C2 6.20808 2 7.13872 2 9L2 14C2 16.8003 2 18.2004 2.54497 19.27C3.02434 20.2108 3.78924 20.9757 4.73005 21.455C5.79961 22 7.19974 22 10 22H14C16.8003 22 18.2004 22 19.27 21.455C20.2108 20.9757 20.9757 20.2108 21.455 19.27C22 18.2004 22 16.8003 22 14V9C22 7.13872 22 6.20808 21.7553 5.45492C21.2607 3.93273 20.0673 2.73931 18.5451 2.24472C17.7919 2 16.8613 2 15 2V2L14.5 2M9 18H15M6 14H18M8 10H16M6 6H18"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"line",
		<Fragment key={"line"}>
			<path
				d="M9 18H15M6 14H18M8 10H16M6 6H18M10 22H14C16.8003 22 18.2004 22 19.27 21.455C20.2108 20.9757 20.9757 20.2108 21.455 19.27C22 18.2004 22 16.8003 22 14V10C22 7.19974 22 5.79961 21.455 4.73005C20.9757 3.78924 20.2108 3.02433 19.27 2.54497C18.2004 2 16.8003 2 14 2H10C7.19974 2 5.79961 2 4.73005 2.54497C3.78924 3.02433 3.02433 3.78924 2.54497 4.73005C2 5.79961 2 7.19974 2 10V14C2 16.8003 2 18.2004 2.54497 19.27C3.02433 20.2108 3.78924 20.9757 4.73005 21.455C5.79961 22 7.19974 22 10 22Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"mono",
		<Fragment key={"mono"}>
			<path
				opacity="0.32"
				d="M9.25 1.25C6.44974 1.25 5.04961 1.25 3.98005 1.79497C3.03924 2.27433 2.27433 3.03924 1.79497 3.98005C1.25 5.04961 1.25 6.44974 1.25 9.25V14.75C1.25 17.5503 1.25 18.9504 1.79497 20.02C2.27433 20.9608 3.03924 21.7257 3.98005 22.205C5.04961 22.75 6.44974 22.75 9.25 22.75H14.75C17.5503 22.75 18.9504 22.75 20.02 22.205C20.9608 21.7257 21.7257 20.9608 22.205 20.02C22.75 18.9504 22.75 17.5503 22.75 14.75V9.25C22.75 6.44974 22.75 5.04961 22.205 3.98005C21.7257 3.03924 20.9608 2.27433 20.02 1.79497C18.9504 1.25 17.5503 1.25 14.75 1.25H9.25Z"
				fill="currentColor"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M5.25 6.00025C5.25 5.58603 5.58579 5.25025 6 5.25025L18 5.25025C18.4142 5.25025 18.75 5.58603 18.75 6.00025C18.75 6.41446 18.4142 6.75025 18 6.75025L6 6.75025C5.58579 6.75025 5.25 6.41446 5.25 6.00025ZM7.25 10.0002C7.25 9.58603 7.58578 9.25024 8 9.25024L16 9.25024C16.4142 9.25024 16.75 9.58603 16.75 10.0002C16.75 10.4145 16.4142 10.7502 16 10.7502L8 10.7502C7.58578 10.7502 7.25 10.4145 7.25 10.0002ZM5.25 14.0002C5.25 13.586 5.58579 13.2502 6 13.2502L18 13.2502C18.4142 13.2502 18.75 13.586 18.75 14.0002C18.75 14.4144 18.4142 14.7502 18 14.7502L6 14.7502C5.58579 14.7502 5.25 14.4144 5.25 14.0002ZM8.24998 18.0002C8.24998 17.586 8.58577 17.2502 8.99998 17.2502L15 17.2502C15.4142 17.2502 15.75 17.586 15.75 18.0002C15.75 18.4145 15.4142 18.7502 15 18.7502L8.99998 18.7502C8.58577 18.7502 8.24998 18.4145 8.24998 18.0002Z"
				fill="currentColor"
			/>
		</Fragment>,
	],
]);
